import { render, staticRenderFns } from "./UpdateProduct.vue?vue&type=template&id=e906727e&scoped=true&"
import script from "./UpdateProduct.vue?vue&type=script&lang=js&"
export * from "./UpdateProduct.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProduct.vue?vue&type=style&index=0&id=e906727e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e906727e",
  null
  
)

export default component.exports